<lib-dialog-layout>
    <ng-container title>
        <div class="d-flex justify-content-between">
            <h3>{{ data.Title }}</h3>
        </div>
    </ng-container>
    <ng-container content>
        <p class="typography-body-medium padding-bottom-24">{{ data.Text }}</p>
        @if (data.ProgressObservable !== undefined){
            <lib-progress-bar 
                [kind]="ProgressBarKind.Determinate" 
                [value]="percentageComplete">
            </lib-progress-bar>
        } @else {
            <lib-progress-bar 
                [kind]="ProgressBarKind.Indeterminate">
            </lib-progress-bar>
        }
    </ng-container>
    <ng-container submissionBar>
        <lib-submission-bar [kind]="SubmissionBarKind.DialogBasic">
            <lib-button
            [role]="ButtonRole.Primary"
                id="LibraryDialogSecondaryButton"
                [kind]="ButtonKind.DangerSecondary"
                [disabled]="!canCancel"
                (clicked)="PrimaryAction()">
                <ng-container label>
                    {{ data.CancelButtonText }}
                </ng-container>
            </lib-button>
        </lib-submission-bar>
    </ng-container>
</lib-dialog-layout>
